export const tableConfig = {
    name: 'visitTransfer',
    fields: [
        {
            label: '转办人',
            prop: 'ownerName',
            value: 'ownerName',
            name: '转办人',
            type: 'custom',
            mustFill: true,
            configClassName: 'visit-flow-form-dialog',
            rule: [
                { required: true, message: '转办人不能为空,请弹窗选择', trigger: 'change' }
            ],
            dialogCloseTips: true
        }
    ],
    height: 325
};
